'use client';

import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { images } from '~/landing/assets';

import { Title } from '../components/title';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const contacts = [
  {
    name: 'Antoine MILLET',
    roleKey: 'ceo' as const,
    image: images.polyseme.contact.ceo,
    linkedin: 'https://www.linkedin.com/in/antoine-millet-4a95b474',
    email: 'antoine@germen.io',
  },
  {
    name: 'Jean-François BONNEVILLE',
    roleKey: 'cco' as const,
    image: images.polyseme.contact.cco,
    linkedin:
      'https://www.linkedin.com/in/jean-fran%C3%A7ois-bonneville-94a31394',
    email: 'jf@germen.io',
  },
] as const;

export const Team = () => {
  const t = useTranslations('landing.polyseme.team');

  return (
    <motion.div
      className="pt-[60px]"
      initial="hidden"
      transition={{ duration: 0.5, ease: 'easeOut' }}
      variants={fadeInUp}
      viewport={{ once: true, amount: 0.3 }}
      whileInView="visible"
    >
      <Title as="h2" className="mb-10 text-center" variant="title-2">
        {t('title')}
      </Title>

      <div className="grid gap-8 md:grid-cols-2">
        {contacts.map((contact) => (
          <article
            key={contact.name}
            className="relative flex flex-col items-center rounded-2xl bg-gray-100 p-8 shadow-sm"
          >
            <div className="relative mb-4 size-36">
              <Image
                fill
                alt={contact.name}
                className="rounded-full object-cover object-top grayscale"
                src={contact.image}
              />
            </div>
            <h3 className="text-lg font-semibold">{contact.name}</h3>
            <p className="text-sm text-gray-500">
              {t(`roles.${contact.roleKey}`)}
            </p>

            <div className="mt-6 flex w-full justify-center gap-4">
              <a
                aria-label={t('linkedinLabel', { name: contact.name })}
                className="rounded-full border-none bg-white p-3.5 text-primary transition-colors hover:cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                href={`mailto:${contact.email}?subject=${encodeURIComponent(t('emailSubject'))}&body=${encodeURIComponent(t('emailBody', { firstName: contact.name.split(' ')[0] ?? '' }))}`}
              >
                <Image
                  alt=""
                  className="size-5"
                  height={20}
                  src={images.polyseme.contact.email}
                  width={20}
                />
              </a>
              <a
                aria-label={t('linkedinLabel', { name: contact.name })}
                className="rounded-full border-none bg-white p-3.5 text-primary transition-colors hover:cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                href={contact.linkedin}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Image
                  alt=""
                  className="size-5"
                  height={20}
                  src={images.polyseme.contact.linkedin}
                  width={20}
                />
              </a>
            </div>
          </article>
        ))}
      </div>
    </motion.div>
  );
};
